/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcknowledgeCurrentUserPylonPendingMessage200ResponseData
 */
export interface AcknowledgeCurrentUserPylonPendingMessage200ResponseData {
    /**
     * 
     */
    success: boolean;
    /**
     * False when a newer message arrived first and was left pending
     */
    cleared: boolean;
}

/**
 * Check if a given object implements the AcknowledgeCurrentUserPylonPendingMessage200ResponseData interface.
 */
export function instanceOfAcknowledgeCurrentUserPylonPendingMessage200ResponseData(value: object): value is AcknowledgeCurrentUserPylonPendingMessage200ResponseData {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('cleared' in value) || value['cleared'] === undefined) return false;
    return true;
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseDataFromJSON(json: any): AcknowledgeCurrentUserPylonPendingMessage200ResponseData {
    return AcknowledgeCurrentUserPylonPendingMessage200ResponseDataFromJSONTyped(json, false);
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcknowledgeCurrentUserPylonPendingMessage200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'cleared': json['cleared'],
    };
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseDataToJSON(json: any): AcknowledgeCurrentUserPylonPendingMessage200ResponseData {
    return AcknowledgeCurrentUserPylonPendingMessage200ResponseDataToJSONTyped(json, false);
}

export function AcknowledgeCurrentUserPylonPendingMessage200ResponseDataToJSONTyped(value?: AcknowledgeCurrentUserPylonPendingMessage200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'cleared': value['cleared'],
    };
}

